"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepper = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _Stepper = _interopRequireDefault(require("@material-ui/core/Stepper"));

var _Step = _interopRequireDefault(require("@material-ui/core/Step"));

var _StepLabel = _interopRequireDefault(require("@material-ui/core/StepLabel"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));

var _styleModule = _interopRequireDefault(require("./TextStepper/style.module.scss"));

var _styleModule2 = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

// this calculates th progress in each section
var calculateProgress = function calculateProgress(index, stepperNodes) {
  var progressArray = [];
  stepperNodes.forEach(function (position, idx, array) {
    if (idx === 0) {} else {
      if (index < array[idx - 1]) {
        progressArray.push(0);
      } else if (index > array[idx - 1] && index < position) {
        progressArray.push((index - array[idx - 1]) / (position - array[idx - 1]) * 100);
      } else {
        progressArray.push(100);
      }
    }
  });
  return progressArray;
};

var StepperIcon = function StepperIcon(props) {
  var active = props.active,
      completed = props.completed;
  return completed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    className: _styleModule2.default.checkIcon,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckCircle.default, {
      fontSize: 'large'
    })
  }) : active ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    className: _styleModule2.default.circleIcon,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioButtonUnchecked.default, {
      fontSize: 'large'
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    className: _styleModule2.default.circleIcon,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioButtonUnchecked.default, {
      fontSize: 'large'
    })
  });
};

var ProgressStepperComponent = function ProgressStepperComponent(_ref) {
  var index = _ref.index,
      stepsLength = _ref.stepsLength,
      sectionSeparatorPositions = _ref.sectionSeparatorPositions,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var amountOfSections = sectionSeparatorPositions.length;
  var stepperNodes = (0, _toConsumableArray2.default)(sectionSeparatorPositions);
  var currentSection = stepperNodes.reduce(function (accumulator, current) {
    return index > current ? accumulator + 1 : accumulator;
  }, 0);

  if (stepperNodes.length <= amountOfSections) {
    stepperNodes.push(stepsLength);
  }

  var defaultStepper = function defaultStepper(index, stepperNodes) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: "".concat(_styleModule2.default.progressStepper),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: "".concat(_styleModule2.default.stepper, " "),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stepper.default, {
          activeStep: currentSection,
          connector: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule2.default.connector
          }),
          children: stepperNodes.map(function (sectionIndex) {
            return sectionIndex === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Step.default, {
              disabled: true,
              hidden: true
            }, "section".concat(sectionIndex, "Step")) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Step.default, {
              disabled: true,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StepLabel.default, {
                StepIconComponent: StepperIcon
              }, "section".concat(sectionIndex, "StepLabel"))
            }, "section".concat(sectionIndex, "Step"));
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: "".concat(_styleModule2.default.linearProgress, " ").concat(amountOfSections === 1 && sectionSeparatorPositions.length === 1 ? _styleModule2.default.smallStep : ''),
        children: progressElements.map(function (element, idx) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            className: idx === 0 ? "".concat(_styleModule2.default.linearProgressElement, " ").concat(_styleModule2.default['linearProgressFirstElement']) : idx === 1 ? "".concat(_styleModule2.default.linearProgressElement, " ").concat(_styleModule2.default.linearProgressLastElement) : _styleModule2.default.linearProgressElement,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinearProgress.default, {
              variant: "determinate",
              color: "secondary",
              value: element,
              classes: {
                root: _styleModule2.default.linearProgressRoot,
                barColorSecondary: _styleModule2.default.linearProgressColorPrimary,
                colorSecondary: _styleModule2.default.linearProgressColorSecondary
              }
            })
          });
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule2.default.clearBoth
      })]
    });
  };

  var textStepper = function textStepper(index) {
    var sectionStepsNumber = sectionSeparatorPositions[1] || stepsLength;

    var currentStepsNumber = function currentStepsNumber() {
      var retVal = 0;

      if (index < sectionStepsNumber) {
        retVal = sectionStepsNumber;
      } else {
        retVal = stepsLength;
      }

      return retVal;
    };

    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule2.default.textStepper,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
        variant: "h5",
        gutterBottom: true,
        className: _styleModule.default.text,
        children: [index, " | ", currentStepsNumber()]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileStepper.default, {
        variant: "progress",
        steps: stepsLength + 1,
        position: "static",
        activeStep: index,
        classes: _styleModule.default
      })]
    });
  };

  var singleStepper = function singleStepper(index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule2.default.textStepper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileStepper.default, {
        variant: "progress",
        steps: stepsLength,
        position: "static",
        activeStep: index,
        classes: _styleModule.default
      })
    });
  };

  var getLayout = function getLayout(index, stepperNodes) {
    switch (variant) {
      case 'default':
        return defaultStepper(index, stepperNodes);

      case 'text':
        return textStepper(index);

      case 'single':
        return singleStepper(index);

      default:
        return defaultStepper(index, stepperNodes);
    }
  };

  var progressElements = calculateProgress(index, stepperNodes);
  return getLayout(index, stepperNodes);
};

var ProgressStepper = /*#__PURE__*/_react.default.memo(ProgressStepperComponent, function (prev, next) {
  return prev.index === next.index && prev.stepsLength === next.stepsLength && JSON.stringify(prev.sectionSeparatorPositions) === JSON.stringify(next.sectionSeparatorPositions);
});

exports.ProgressStepper = ProgressStepper;